import { css } from "@emotion/react";

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const headerStyle = css`
  display: flex;
  justify-content: space-between;
  height: 131px;
  line-height: 22px !important;

  @media only screen and (max-width: 992px) {
    height: auto;
    padding: 16px;
  }
`;

export const titleStyle = css`
  margin-bottom: 13px !important;
  font-size: 20px !important;
  line-height: 22px !important;
  display: inline-block;

  @media only screen and (max-width: 992px) {
    font-size: 16px !important;
  }
`;

export const iconStyle = css`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: top;
`;

export const contentStyle = css`
  background-color: #ffffff;
  padding: 24px;
  margin-left: 24px;
  margin-right: 24px;
  height: calc(100vh - 215px);
  overflow: hidden;

  @media only screen and (max-width: 992px) {
    padding: 16px;
    margin-left: 12px;
    margin-right: 12px;
    height: auto;
    overflow: visible;
    flex: 1;
  }
`;

export const footerStyle = css`
  margin-top: 24px;
  border-top: 1px solid #e3e3e4;
`;

export const toolbarStyle = css`
  width: 100%;
`;
